// ** Router imports
import { lazy } from 'react'
// ** Router imports
import { useRoutes } from "react-router-dom"

// ** GetRoutes
import { getRoutes } from "./routes"

// ** Hooks Imports
import { useLayout } from "@hooks/useLayout"

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'
import { Navigate } from 'react-router-dom'
import { getUserData, getHomeRouteForLoggedInUser } from '../utility/Utils'
import ForgotPassword from '../views/ForgotPassword'
import TwoStepsBasic from '../views/TwoStepBasic'
import ResetPassword from '../views/ResetPassword'
import CardCongratulations from '../views/ui-elements/cards/advance/CardCongratulations'
import { handleLogout } from '@store/authentication'
import { useDispatch } from 'react-redux'
// ** Components
const Error = lazy(() => import('../views/Error'))
const NotAuthorized = lazy(() => import('../views/NotAuthorized'))
const Login = lazy(() => import('../views/Login'))

const Router = () => {
  // ** Hooks
  const dispatch = useDispatch()
  const { layout } = useLayout()
  const allRoutes = getRoutes(layout)
  // const getHomeRoute = () => {
  //   const user = getUserData()
  //   if (user) {
  //     return getHomeRouteForLoggedInUser(user.user_role.name)
  //   } else {
  //     return '/login'
  //   }
  // }

  const routes = useRoutes([
    {
      path: '/',
      index: true,
      element: <Navigate replace to={'/dashboard'} />
    },
    {
      path: '/misc/not-authorized',
      element: <BlankLayout />,
      children: [{ path: '/misc/not-authorized', element: <NotAuthorized /> }]
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />,
      layout: 'BlankLayout',
      meta: {
        layout: 'blank',
        publicRoute: true,
        restricted: true
      }
    },
    {
      path: `/reset-password`,
      element: <ResetPassword />,
    },
    // {
    //   path: `/logout`,
    //   element: dispatch(handleLogout()),
    // },
    {
      path: '/verificationCode',
      element: <TwoStepsBasic />,
      meta: {
        layout: 'blank'
      }
    },

    {
      path: '*',
      element: <BlankLayout />,
      children: [{ path: '*', element: <Error /> }]
    },
    ...allRoutes
  ])

  return routes
}

export default Router
